import api from "../../../../../services/api";

// Tags de circuito (POP/Regional), tabela genérica `Tags` filtrada por `type`.
// Extraído de circuito/index.js (etapa 19 do plano) — mesmas chamadas, sem mudança de payload.

export const createTagCircuito = async (tag) => {
  const response = await api.post("/interno/create/tagsCircuito", tag);
  return response?.data;
};

export const updateTagCircuito = async (tag) => {
  const response = await api.post("/interno/update/tagsCircuito", tag);
  return response?.data;
};

export const deleteTagCircuito = async (id) => {
  const response = await api.post("/interno/delete/tagsCircuito", { id });
  return response?.data;
};

export const findManyTagsCircuito = async (type) => {
  const response = await api.post("/interno/findMany/tagsCircuito", { type });
  return response?.data;
};
